module.exports = __webpack_public_path__ + "img/HG4101-02.68a2c9c4.jpg";